<template>
  <div>
    <SideBar :title="customer.company.fantasy_name" v-model="onEditCompaign" v-if="onEditCompaign" :onLoad="onLoad"
             redirectTo="/clientes/">
      <cliente @edited="companyEdited" :customer="customer" @loading="status => onLoad = status"></cliente>
    </SideBar>
    <SideBar v-model="onCreateCompaign" v-if="onCreateCompaign" title="Nova Empresa" :onLoad="onLoad"
             redirectTo="/clientes">
      <cliente @created="compaignCreated" @loading="status => onLoad = status"
               @closeSidebar="onCreateCompaign = false"></cliente>
    </SideBar>
    <SideBar v-if="onShowCompanyOrders" v-model="onShowCompanyOrders">
      <Order :company_id="customer.company.id_company"></Order>
    </SideBar>

    <listView :onLoad="onLoadData" v-show="!onCreateCompaign && !onShowCompanyOrders && !onEditCompaign">
      <template slot="options-totalizer">
        <vs-row class="mt-2">Exibindo {{ customersFiltered.length }} de {{ pageInfo.total || 0 }} clientes</vs-row>
      </template>
      <template slot="sidebar-body">
        <div class="mt-2">
          <ul class="overflow-auto flex flex-col">
            <div class="flex flex-row justify-between items-center">
              <h6>Clientes</h6>
              <vx-tooltip text="Resetar filtros">
                <vs-button
                  color="primary"
                  type="flat"
                  @click="clearFilter"
                  :disabled="filters.empty"
                  icon-pack="feather"
                  icon="icon-slash"
                ></vs-button>
              </vx-tooltip>
            </div>
            <ul class="leftx">
              <li v-for="(type, index) in filters.companyStatus.status" :key="index" @input="toQueryFilter">
                <vs-radio v-model="filters.companyStatus.statusModel" :name="type.name" :vs-value="type.value">
                  {{ ` ${type.name} (${filters.companyStatus.totalStatus[type.value] || 0})` }}
                </vs-radio>
              </li>
            </ul>
          </ul>
        </div>

        <vs-divider/>

        <div class="mt-2">
          <div class="flex justify-between flex-row">
            <h6 class="p-3">Ramo da empresa</h6>
          </div>
          <vs-input class="mb-2 mt-4" label-placeholder="Procure um ramo" v-model="search_companySegment"></vs-input>
          <ul class="centerx overflow-auto filterHeight">
            <VuePerfectScrollbar class="scroll-area">
              <li class="flex justify-between pr-2" v-for="(type, index) in companySegmentComputed" :key="index">
                <vs-checkbox v-model="filters.companySegment.values" :vs-value="type.value"
                             @change.native.stop="toQueryFilter">{{ type.name }}
                </vs-checkbox>
                ({{ type.total }})
              </li>
            </VuePerfectScrollbar>
          </ul>
        </div>
        <div class="mt-2 hidden">
          <h6>Tamanho da empresa</h6>
          <ul class="centerx mt-2 filterHeight">
            <li class="flex justify-between pr-2" v-for="(type, index) in companySizeComputed" :key="index">
              <vs-checkbox v-model="filters.companySize.values" :vs-value="type.value"
                           @change.native.stop="toQueryFilter">{{ type.name }}
              </vs-checkbox>
              ({{ type.total }})
            </li>
          </ul>
        </div>
        <vs-divider/>
        <div class="mt-2">
          <h6>Estado</h6>
          <ul class="centerx overflow-auto filterHeight">
            <VuePerfectScrollbar class="scroll-area">
              <li class="flex justify-between pr-2" v-for="(type, index) in companyRegionComputed" :key="index">
                <vs-checkbox v-model="filters.companyRegion.values" :vs-value="type.value"
                             @change.native.stop="toQueryFilter">{{ type.name }}
                </vs-checkbox>
                ({{ type.total }})
              </li>
            </VuePerfectScrollbar>
          </ul>
        </div>
      </template>
      <template slot="container-header">
        <div class="relative mb-8">
          <!-- SEARCH INPUT -->
          <vs-input icon-pack="feather" class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                    placeholder="Pesquisar" v-model="filters.name" size="large"/>

          <!-- SEARCH ICON -->
          <div slot="submit-icon" class="absolute pin-t pin-r py-4 px-6">
            <feather-icon icon="SearchIcon" svgClasses="h-6 w-6"/>
          </div>
        </div>
      </template>
      <template slot="container-body">
        <div v-if="!customersFiltered.length && !onLoadData" class="text-center text-3xl">
          Você não possui clientes ou não existe clientes para o filtro aplicado.
        </div>
        <div v-if="isMobile && (customersFiltered.length && !onLoadData)">
          <div class="ml-2">Exibindo {{ customersFiltered.length }} de {{ pageInfo.total || 0 }} clientes</div>
          <vx-collapse accordion type="margin" class="p-0 bg-white">
            <vx-collapse-item>
              <div slot="header" class="flex">
                <feather-icon icon="FilterIcon"></feather-icon>
                Ordenação
              </div>
              <div class="flex flex-col">
                <div class="flex justify-between w-full p-2 items-center">
                  <span>Ordernar por</span>
                  <vs-select
                    v-model="sort.sortBy"
                    @change="() => toQueryFilter(sort.direction, sort.sortBy)"
                  >
                    <vs-select-item
                      v-for="column in sort.sortableColumns"
                      :key="column.key"
                      :value="column.key"
                      :text="column.name"
                    >

                    </vs-select-item>
                  </vs-select>
                </div>
                <div class="flex justify-between w-full p-2 items-center">
                  <span>Direção</span>
                  <vs-select
                    v-model="sort.direction"
                    @change="() => toQueryFilter(sort.direction, sort.sortBy)"
                  >
                    <vs-select-item
                      v-for="direction in sort.directions"
                      :key="direction.key"
                      :value="direction.key"
                      :text="direction.name"
                    >

                    </vs-select-item>

                  </vs-select>
                </div>
              </div>
            </vx-collapse-item>
          </vx-collapse>
        </div>
        <div ref="listaClientes" class="overflow-auto h-full w-full" @scroll.passive="handleScroll"
             v-if="customersFiltered.length">
          <vs-table id="table-clientes" :data="customersFiltered" v-if="!isMobile">
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th>
                <span class="sort-th">
                  <i @click="sortTable('desc','id_company')" class="material-icons up-sort">expand_less</i>
                  <i @click="sortTable('asc','id_company')" class="material-icons down-sort">expand_more</i>
                </span>
                #
              </vs-th>
              <vs-th width="500px">
                <span class="sort-th">
                  <i @click="sortTable('desc','fantasy_name')" class="material-icons up-sort">expand_less</i>
                  <i @click="sortTable('asc','fantasy_name')" class="material-icons down-sort">expand_more</i>
                </span>
                Nome
              </vs-th>
              <vs-th>
                <span class="sort-th">
                  <i @click="sortTable('desc','system')" class="material-icons up-sort">expand_less</i>
                  <i @click="sortTable('asc','system')" class="material-icons down-sort">expand_more</i>
                </span>
                Plano
              </vs-th>
              <vs-th>
                <span class="sort-th">
                  <i @click="sortTable('desc','price')" class="material-icons up-sort">expand_less</i>
                  <i @click="sortTable('asc','price')" class="material-icons down-sort">expand_more</i>
                </span>
                Valor Plano
              </vs-th>
              <vs-th>
                <span class="sort-th">
                  <i @click="sortTable('desc','expiration_date')" class="material-icons up-sort">expand_less</i>
                  <i @click="sortTable('asc','expiration_date')" class="material-icons down-sort">expand_more</i>
                </span>
                Data Vencimento
              </vs-th>
              <vs-th>
                <span class="sort-th">
                  <i @click="sortTable('desc','last_login_at')" class="material-icons up-sort">expand_less</i>
                  <i @click="sortTable('asc','last_login_at')" class="material-icons down-sort">expand_more</i>
                </span>
                Último login
              </vs-th>
              <vs-th>Ações</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(user, indextr) in data"
                     :class="user.expired_subscription ? 'expired-subscription' : ''">
                <vs-td>
                  <vx-tooltip :text="user.expired_subscription ? 'Mensalidade atrasada' : 'Mensalidade em dia'"
                              position="top">
                    <vs-icon :icon="user.expired_subscription ? 'thumb_down_alt' : 'thumb_up_alt'"
                             :class="user.expired_subscription ? 'overdue': ''"></vs-icon>
                  </vx-tooltip>
                </vs-td>
                <vs-td :data="user.id_company">
                  {{ user.id_company }}
                </vs-td>
                <vs-td :data="user.fantasy_name">
                  {{ user.fantasy_name }}
                </vs-td>
                <vs-td :data="user.system">
                  {{ user.system }}
                </vs-td>
                <vs-td :data="user.price">
                  <div class="column-payment">
                    {{ (user.price ? (user.price) : '') | formatMoney }}
                    <vx-tooltip
                      :text="user.boletoPayment ? `Boleto gerado em: ${user.boletoCreatedAt}` : user.cardPayment > 0 ? 'Pagamento no cartão' : ''"
                      position="top"
                      class="ml-2"
                    >
                      <font-awesome-icon
                        :icon="user.cardPayment > 0 ? 'creditCard' : user.boletoPayment  ? 'barcode': ''"
                        v-if="user.cardPayment || user.boletoPayment"/>
                    </vx-tooltip>
                  </div>
                </vs-td>
                <vs-td>
                  <div v-if="(user.expiration_date && user.expiration_date != undefined)">
                    <span>{{ user.expiration_date | formatDate }}</span>
                    <vx-tooltip text="Tempo em atraso">
                      <span>{{ humanize(user.expiration_date) }}</span>
                    </vx-tooltip>
                  </div>
                  <span v-else>Não há parcela</span>
                </vs-td>
                <vs-td>
                  <div v-if="user.last_login_at">{{ humanizeLoginDate(user.last_login_at) }}</div>
                  <div v-else>Sem registro</div>
                </vs-td>
                <vs-td>
                  <vs-row vs-type="flex" vs-align="flex-end" v-if="user.isActive">
                    <vs-button class="mr-2" v-tooltip.top="`Editar empresa`" type="flat" icon="edit"
                               @click="editCompaign(user.id_company)"></vs-button>
                    <vs-button class="mr-2" v-tooltip.top="`Realizar venda`" type="flat" icon-pack="feather"
                               icon="icon-shopping-bag" @click="toSale(user)"></vs-button>
                    <vs-button type="flat" v-tooltip.top="`Reenviar e-mail`" icon-pack="feather" icon="icon-send"
                               @click="sendEmail(user.id_company)"></vs-button>
                  </vs-row>
                  
                  <!-- Ainda permite editar, mas só editar -->
                  <vs-row vs-type="flex" vs-align="flex-end" v-else>
                    <vs-button class="mr-2" v-tooltip.top="`Editar empresa`" type="flat" icon="edit"
                               @click="editCompaign(user.id_company)"></vs-button>
                  </vs-row>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div v-else>
            <vx-collapse accordion type="margin" class="p-0 bg-white">
              <vx-collapse-item v-for="company in customersFiltered" :key="company.id_company">
                <div slot="header" class="flex" :class="{'expired-subscription': company.expired_subscription}">
                  <span>{{ company.id_company }} - {{ company.fantasy_name }}</span>
                </div>
                <div class="flex flex-col">
                  <div class="flex justify-between w-full p-2">
                    <span>Plano</span>
                    <span>{{ company.system }}</span>
                  </div>
                  <div class="flex justify-between w-full p-2">
                    <span>Valor</span>
                    <span v-if="company.price">{{ company.price | formatMoney }}</span>
                    <span v-else>Sem parcela</span>
                  </div>
                  <div class="flex justify-between w-full p-2">
                    <span>Data Vencimento</span>
                    <span v-if="company.expiration_date">{{ company.expiration_date | formatDate }}</span>
                    <span v-else>Sem parcela</span>
                  </div>
                  <div class="flex justify-between w-full p-2" v-if="company.expired_subscription">
                    <span>Dias em atraso</span>
                    <span>{{ humanize(company.expiration_date) }}</span>
                  </div>
                  <div class="flex justify-between w-full p-2" v-if="company.boletoCreatedAt">
                    <span>Boleto gerado em:</span>
                    <span>{{ company.boletoCreatedAt }}</span>
                  </div>
                  <div class="flex justify-between w-full p-2">
                    <span>Último login</span>
                    <span v-if="company.last_login_at">{{ humanizeLoginDate(company.last_login_at) }}</span>
                    <span v-else>Sem registro</span>
                  </div>
                  <vs-button type="flat" color="primary" @click="editCompaign(company.id_company)">Editar</vs-button>
                  <vs-button type="flat" color="success" @click="toSale(company)">Vender</vs-button>
                  <vs-button type="flat" color="danger" @click="sendEmail(company.id_company)">Reenviar email de
                    ativação
                  </vs-button>
                </div>
              </vx-collapse-item>
            </vx-collapse>
          </div>
        </div>
      </template>
    </listView>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment';
import accounting from 'accounting';
import {mapGetters} from 'vuex'

export default {
  filters: {
    formatMoney(value) {
      if (value == "" || value == undefined) {
        return "R$ 0,00";
      }
      return accounting.formatMoney(value, 'R$', 2, ".", ",")
    },

    formatDate(date) {
      if (date == "") {
        return "Sem data"
      }
      return moment(date).format("DD/MM/YYYY")
    }
  },

  components: {
    cliente: () => import("./Cliente/Cliente"),
    Order: () => import("./Cliente/Order"),
    SideBar: () => import("../components/SideBar/SideBar"),
    listView: () => import("../components/list-view/list-view"),
    VuePerfectScrollbar
  },
  data() {
    return {
      customers: [],
      onEditCompaign: false,
      onCreateCompaign: false,
      onShowCompanyOrders: false,
      customer: {},
      pageInfo: {},
      onLoad: false,
      onLoadData: false,
      search_companySegment: '',
      search_region_name: '',
      sort: {
        sortableColumns: [
          {name: 'Id da empresa', key: 'id_pessoa'},
          {name: 'Data de Vencimento', key: 'data_vencimento'},
          {name: 'Nome', key: 'nome'},
          {name: 'Valor', key: 'valor'},
        ],
        directions: [
          {name: 'Ascendente', key: 'asc'},
          {name: 'Decrescente', key: 'desc'}
        ],
        sortBy: 'id_pessoa',
        direction: 'desc'
      },
      filters: {
        companySegment: {
          options: [],
          values: []
        },
        companySize: {
          options: [],
          values: []
        },
        companyRegion: {
          options: [],
          values: []
        },
        login: {
          periodTypes: [{name: 'Semana', value: 'week'}, {name: 'Mês', value: 'month'}, {name: 'Ano', value: 'year'}],
          period: 0,
          periodType: 'week'
        },
        companyStatus: {
          status: [{name: 'Ativos', value: 1}, {name: 'Inativos', value: 2}],
          totalStatus: [],
          statusModel: 1
        },
        name: '',
        empty: true
      },
      sorting: [],
      order: 'desc', // Variavel para ordenação local da tabela
      columnSort: 'id_company', // Variavel para determinar qual coluna está ordenando a tabela (Por Padrão ID)
    }
  },

  computed: {
    ...mapGetters(["isMobile"]),

    customersFiltered() {
      return this.customers.map(customer => ({
        id_company: customer.company.id_company,
        system: customer.system.name || 'Não possui',
        fantasy_name: customer.company.fantasy_name,
        registration_date: customer.company.registration_date.date,
        document_number: customer.company.document_number,
        expiration_date: customer.company.billing.expiration_date,
        expired_subscription: customer.company.billing.expired_subscription,
        price: customer.company.billing.price,
        cardPayment: customer.company.billing.creditCardPayment,
        boletoPayment: customer.company.billing.hasBoleto,
        boletoCreatedAt: customer.company.billing.boleto ? JSON.parse(atob(customer.company.billing.boleto)).data_processamento : '',
        isActive: customer.company.isActive,
        last_login_at: customer.company.last_login_at
      }))
        // Filtra a lista localmente com base no texto digitado (filters.name)
        .filter(customer =>
          Object.entries(customer)
            .filter(col => {
              const filterValue = this.filters.name
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

              if (isNaN(this.filters.name) && typeof col[1] === 'string') {
                const colValue = col[1]
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '');

                return colValue.indexOf(filterValue) > -1;
              }

              if (typeof col[1] === 'number') {
                return String(col[1]).indexOf(this.filters.name) > -1;
              }

              return false;
          }).length > 0
        ).sort((a, b) => {
          // Verifica se está em ordenação crescente
          const isAsc = this.order == 'asc' ? 1 : -1;
          // Função para verificar se é uma data no formato DD/MM/YYYY
          const isDate = (value) => {
            return value && typeof value === 'string' && ( /^\d{2}\/\d{2}\/\d{4}$/.test(value) ||
              /^\d{2}-\d{2}-\d{4}$/.test(value));
          };
          // Função para converter de DD/MM/YYYY para YYYY-MM-DD
          const parseDate = (dateStr) => {
            const [day, month, year] = dateStr.split('/');
            return new Date(`${year}-${month}-${day}`);
          };
          const valueA = a[this.columnSort];
          const valueB = b[this.columnSort];
          // Verifica se algum valor é null ou undefined
          if (valueA == null && valueB != null) return 1;
          if (valueB == null && valueA != null) return -1;
          if (valueA == null && valueB == null) return 0;
          // Verifica se é uma data
          if (isDate(valueA) && isDate(valueB)) {
            const dateA = parseDate(valueA);
            const dateB = parseDate(valueB);
            return isAsc * (dateA - dateB);
          }
          // Caso não seja uma data, compara String || Number
          return isAsc * (valueA > valueB ? 1 : -1);
        })
    },

    companySizeComputed() {
      return this.filters.companySize.options;
    },

    companySegmentComputed() {
      if (this.search_companySegment) {
        return this.filters.companySegment.options.filter(type => !type.name.toLowerCase().indexOf(this.search_companySegment.toLowerCase()));
      }

      return this.filters.companySegment.options;
    },

    companyRegionComputed() {
      if (this.search_region_name) {
        return this.filters.companyRegion.options.filter(region => !region.name.toLowerCase().indexOf(this.search_region_name.toLowerCase()));
      }

      return this.filters.companyRegion.options;
    }
  },
  watch: {
    'filters.name': {
      handler: _.debounce(function () {
        this.toQueryFilter();
      }, 600)
    }
  },
  methods: {
    goBack() {
      this.$router.push('clientes');
    },

    toSale(user) {
      this.$router.push({
        name: 'checkout',
        params: {
          customer: user,
          customerId: user.id_company
        }
      })
    },

    editCompaign(companyId) {
      this.customer = this.customers.find(customer => customer.company.id_company === companyId);
      this.onEditCompaign = true;
      this.$router.push(`/clientes/${this.customer.company.fantasy_name}`);
    },

    toQueryFilter: _.debounce(async function (sort = null, column = null) {
      this.onLoadData = true;
      this.sorting = JSON.stringify({"sort": sort || "", "column": column || ""});
      const {data} = await this.$axios.get('company/q', {
        params: {
          segmento_empresa: (this.filters.companySegment.values.length > 0 ? this.filters.companySegment.values.join('|') : null),
          tamanho_empresa: (this.filters.companySize.values.length > 0 ? this.filters.companySize.values.join('|') : null),
          estado: (this.filters.companyRegion.values.length > 0 ? this.filters.companyRegion.values.join('|') : null),
          nome: this.filters.name,
          period: this.filters.login.period ? this.filters.login.period : null,
          periodType: this.filters.login.periodType,
          tipo_cliente: this.filters.companyStatus.statusModel,
          sorting: this.sorting
        }
      });

      if (this.filters.companySegment.values.length > 0 &&
        this.filters.companySize.values.length > 0 &&
        this.filters.companyRegion.values.length > 0 &&
        this.filters.name
      ) {
        this.filters.empty = true;
      } else {
        this.filters.empty = false;
      }

      this.pageInfo = {...data.meta, ...data.links};
      this.customers = data.data;
      this.onLoadData = false;

    }, 350),

    async loadFilters() {
      const {data} = await this.$axios.get("company/filters");
      this.filters.companySegment.options = _.orderBy(data.companySegment, ['total'], ['desc']).map(type => ({
        name: type.name || 'Sem segmento',
        total: type.total,
        value: type.name
      }));

      this.filters.companySize.options = _.orderBy(data.companySize, ['total'], ['desc']).map(type => ({
        name: type.name || 'Sem tamanho',
        total: type.total,
        value: type.name
      }));

      this.filters.companyRegion.options = _.orderBy(data.companyRegion, ['total'], ['desc']).map(type => ({
        name: type.name || 'Sem estado',
        total: type.total,
        value: type.name
      }));

      this.filters.companyStatus.totalStatus = data.companyStatus.map(type => ({
        name: type.name,
        value: type.total = type.total || 0
      })).reduce((arr, item) => {
        arr[item.name] = item.value;
        return arr;
      }, []);
    },

    clearFilter() {
      this.filters.companySize.values = [];
      this.filters.companySegment.values = [];
      this.filters.companyRegion.values = [];
      this.filters.name = '';
      this.filters.companyStatus.statusModel = 1;
      this.filters.login.periodType = 'week';
      this.filters.login.period = 0;
      this.toQueryFilter();
    },
    showOrders(customer) {
      this.customer = this.customersFiltered[customer];
      this.onShowCompanyOrders = true;
    },
    compaignCreated(compaign) {
      this.customers.push(compaign);
    },

    companyEdited(company) {
      const index = this.customers.findIndex(customer => customer.company.company_id === company.company.company_id);
      if (index > -1) {
        this.customers[index] = company;
      }
    },

    formatDate(date) {
      if (date == "") {
        return "Sem data"
      }
      return moment(date).format("DD/MM/YYYY")
    },

    humanize(overdueDate) {
      let now = moment(new Date());
      let time = moment(now.diff(overdueDate));
      if (time._i > 0 && moment(overdueDate).format('YYYY-MM-DD') < now.format('YYYY-MM-DD')) {
        return moment.duration(time._i).humanize();
      }

      return '';
    },

    humanizeLoginDate(overdueDate) {
      let now = moment(new Date());

      if (moment(overdueDate).format('YYYY-MM-DD') === now.format('YYYY-MM-DD')) {
        return "agora mesmo";
      }

      return this.humanizeDate(overdueDate);
    },

    humanizeDate(overdueDate) {
      let now = moment(new Date());
      let time = moment(now.diff(overdueDate));
      if (time._i > 0) {
        return moment.duration(time._i).humanize();
      }
    },

    async sendEmail(id_compay) {
      const {data} = await this.$axios.post('company/email', {
        id_company: id_compay,
        type: "owner",
        resend: true
      })
      data.status ?
        this.$vs.notify({title: "Sucesso", text: data.message, color: "success", time: 5000}) :
        this.$vs.notify({title: "Erro", text: data.message, color: "danger", time: 5000})
    },

    handleScroll: _.debounce(async function ({target}) {
      if ((target.scrollHeight - target.offsetHeight) - target.scrollTop <= 2) {
        if (this.pageInfo.current_page < this.pageInfo.last_page) {
          this.onLoadData = true;
          const {data} = await this.$axios.get(this.pageInfo.next, {
            params: {
              tipo_cliente: this.filters.companyStatus.statusModel,
              sorting: this.sorting
            }
          });
          this.pageInfo = {...data.meta, ...data.links};
          this.customers = [...this.customers, ...data.data];
          this.onLoadData = false;
        }
      }
    }, 1000),

    sortTable(order, column) {
      this.order = order
      this.columnSort = column
    },

    reverseDate(date) {
      return date.split('/').reverse().join('-')
    }
  },
  created() {
    this.loadFilters();
    this.toQueryFilter();
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.name === 'novo') {
        vm.onCreateCompaign = true;
      } else if (to.name === 'edicao') {
        vm.$router.push('/clientes');
      }
    })
  },

  beforeRouteUpdate(to, from, next) {
    if (to.name === 'novo') {
      this.onCreateCompaign = true;
    } else if (to.params.name) {
      this.onEditCompaign = true;
      to.meta.breadcrumb[to.meta.breadcrumb.length - 1].title = to.params.name;
    } else {
      this.onCreateCompaign = false;
      this.onEditCompaign = false;
    }

    next();
  }
}
</script>

<style lang="scss">
.filterHeight {
  height: 16vh;
}

.expired-subscription * {
  color: rgb(240, 65, 65);
}

#table-clientes {
  .td-check {
    display: none !important;
  }
}

.column-payment {
  display: flex;
  flex-direction: row;
}

.icon-payment {
  margin-left: 5px;
  font-size: 20px;
}
</style>
